
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ECommOrderDialog extends _Ext.TransDialog<ECommOrderRow, any> {

        protected getFormKey() { return ECommOrderForm.formKey; }
        protected getIdProperty() { return ECommOrderRow.idProperty; }
        protected getLocalTextPrefix() { return ECommOrderRow.localTextPrefix; }
        protected getNameProperty() { return ECommOrderRow.nameProperty; }
        protected getService() { return ECommOrderService.baseUrl; }
        protected getDeletePermission() { return ECommOrderRow.deletePermission; }
        protected getInsertPermission() { return ECommOrderRow.insertPermission; }
        protected getUpdatePermission() { return ECommOrderRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new ECommOrderForm(this.idPrefix);
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ECommExchangeRate: number;
         
        TaxArray: any[];

        constructor() {
            super();
            //Make grid full width
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            q.initItemEditor(this, this.form.ReceiptDetails, Config);

            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.ItemDetails);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.ReceiptAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            q.hideEditorLabel(this.form.ReceiptDetails);
            q.SetSix12Column(this.form.ReceiptDetails);

            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ProductItemImage);
            q.SetCategoryFourColumn(this.form.BillingAddress);
            q.SetCategoryTwoColumn(this.form.VoucherTypeId);
            q.SetCategoryFourColumn(this.form.ShippingAddress);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.FinancialYearId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);

            q.hideEditorCategoryLabel(this.form.TransDate.element);
            q.hideEditorCategoryLabel(this.form.ProductItemImage.element);
            q.hideEditorCategoryLabel(this.form.VoucherTypeId.element);
            q.hideEditorCategoryLabel(this.form.BillNo.element);
            q.hideEditorCategoryLabel(this.form.ItemDetails.element);
            q.hideEditorCategoryLabel(this.form.ReceiptDetails.element);
            q.hideEditorCategoryLabel(this.form.Pieces.element);
            q.hideEditorCategoryLabel(this.form.NetAmount.element);
            q.hideEditorCategoryLabel(this.form.Remark.element);
            q.hideEditorLabel(this.form.PromoDetails);
            q.hideEditorToolbar(this.form.PromoDetails);


            // **** Get Party Details using PartyID **** 
            this.form.POSCustomerId.changeSelect2(e => {
                var customerid = parseInt(this.form.POSCustomerId.value);
                if (customerid > 0) {
                    let PartyDetails: OMS.PosCustomerMasterRow
                    OMS.PosCustomerMasterService.Retrieve({ EntityId: customerid }, response => { PartyDetails = response.Entity }, { async: false });
                    var firstname = PartyDetails.FirstName == undefined ? "" : PartyDetails.FirstName;
                    var lastname = PartyDetails.LastName == undefined ? "" : PartyDetails.LastName;
                    this.form.CustomerName.value = firstname + " " + lastname;
                    this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value.toString());
                    this.form.GrossAmount.value = 0;

                    let customerdetails: OMS.PosCustomerMasterRow;
                    OMS.PosCustomerMasterService.Retrieve({ EntityId: customerid }, response => {
                        customerdetails = response.Entity;
                        this.form.CustomerName.value = customerdetails.FirstName + customerdetails.LastName;
                        this.form.Mobile.value = customerdetails.Mobile;
                        this.form.Email.value = customerdetails.Email;

                        if (customerdetails != undefined) {
                            this.form.BillingAddress.value = customerdetails.Address;
                            this.form.BillingCityName.value = customerdetails.CityName;
                            this.form.BillingStateName.value = customerdetails.StateName;
                            this.form.BillingCountryName.value = customerdetails.CountryName;
                            this.form.BillingCity.value = customerdetails.CityId;
                            this.form.BillingState.value = customerdetails.StateId;
                            this.form.BillingCountry.value = customerdetails.CountryId;
                            this.form.BillingPin.value = customerdetails.Pin;
                        }
                    })

                }
            });
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });

             
            //this.form.DepartmentId.changeSelect2(e => {
            //    this.form.ItemDetails.DeptId = parseInt(this.form.DepartmentId.value);
            //});



            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;
            var Receipts: any;
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getTotalRows();
                if (ItemTotal > 0) {
                    ItemTotal = 0;
                }

                this.CalculateAmountandTax(Items, TotalItems);

            });
            (this.form.ReceiptDetails.view as any).onRowCountChanged.subscribe(() => {

                this.calculateReceiptTotal();
            });

            this.form.GrossAmount.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.alert("There are no Items added in transaction. Can not save!!")
                    return "";
                }
            });
            this.form.ShippingCity.changeSelect2(e => {
                this.form.ShippingCityName.value = this.form.ShippingCity.text;
                this.validateShippingAddress();
            });

            this.form.ShippingState.changeSelect2(e => {
                this.form.ShippingStateName.value = this.form.ShippingState.text;
                this.form.ShippingCity.cascadeField = "StateId";
                this.form.ShippingCity.cascadeValue = this.form.ShippingState.value;
                Serenity.EditorUtils.setReadOnly(this.form.ShippingCity, false);

                this.validateShippingAddress();
            });
            this.form.ShippingCountry.changeSelect2(e => {
                this.form.ShippingCountryName.value = this.form.ShippingCountry.text;
                this.form.ShippingState.cascadeField = "CountryId";
                this.form.ShippingState.cascadeValue = this.form.ShippingCountry.value;
                this.form.ShippingCity.cascadeField = "StateId";
                this.form.ShippingCity.cascadeValue = this.form.ShippingState.value;

                Serenity.EditorUtils.setReadOnly(this.form.ShippingState, false);

                this.validateShippingAddress();
            });
            this.form.ShippingAddress.changeSelect2(e => {
                this.validateShippingAddress();
            });
            this.form.ShippingPincode.changeSelect2(e => {
                this.validateShippingAddress();
            });
            this.validateForm();


        }

        public CalculateAmountandTax(Items: any, TotalItems: number) {
            if (!this.isViewMode()) {

                var Promos = [];
                var ProductType = [];
                var ProductAmount = [];
                var ProductLabour = [];
                var codearray = [];
                var amtarray = []; 
                var ItemTotal = 0;
                var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var nwt = 0; var wt = 0;

                //Items.forEach(function (x)
                for (var x of Items) {
                    ntamt += x.NetAmount || 0;
                    gramt += x.GrossAmount || 0;
                    disc += x.Discount || 0;
                    pcs += x.Pieces || 0;
                    wt += x.Weight || 0;
                    nwt += x.NetWeight || 0;

                    if (x.HSN != null || x.HSN != "NA") {
                        var temp = false;
                        for (let i = 0; i < codearray.length; i++) {
                            if (codearray[i] == x.HSN) {
                                amtarray[i] += x.GrossAmount || 0;
                                temp = true;
                            }
                        }

                        if (!temp) {
                            codearray.push(x.HSN);
                            amtarray.push(x.GrossAmount);
                        }
                    }
                    // **** To calculate Values for Promotion ****
                    if (x.ProductTypeId != null) {
                        var temp = false;
                        for (let i = 0; i < ProductType.length; i++) {
                            if (ProductType[i] == x.ProductTypeId) {
                                ProductAmount[i] += x.GrossAmount || 0;
                                ProductLabour[i] += x.UnitLabour || 0;
                                temp = true;
                            }
                        }

                        if (!temp) {
                            ProductType.push(x.ProductTypeId);
                            ProductAmount.push(x.GrossAmount);
                            ProductLabour.push(x.UnitLabour);
                        }
                    }

                    ItemTotal++;
                };

                this.form.NetAmount.value = gramt;
                this.form.Discount.value = disc;
                //**** Get and Apply Promotion
                if (ItemTotal == TotalItems) {
                    var Discount: number;
                    for (let i = 0; i < ProductType.length; i++) {

                        var baseitemid = ProductType[i];
                        var date = q.formatDate(this.form.TransDate.value, "dd/MM/yyyy");
                        var Promo;
                        //OMS.PromotionDetailsRow.getLookup().items.filter(x => x.ProductTypeId == baseitemid
                        //    && x.CompanyId == Q.Authorization.userDefinition.CompanyId
                        //    && x.IsDisabled == true && x.IsApproved == true
                        //    && new Date(x.FromDate) <= this.form.TransDate.valueAsDate
                        //    && new Date(x.ToDate) >= this.form.TransDate.valueAsDate
                        //)[0];

                        OMS.PromotionDetailsService.GetPromotions({
                            ProductTypeId: baseitemid,
                            CompanyId: Q.Authorization.userDefinition.CompanyId,
                            IsDisabled: true, IsApproved: true,
                            FromDate: this.form.TransDate.value,
                            ToDate: this.form.TransDate.value
                        }, response => {
                            if (response.Entities != null && response.Entities.length > 0)
                                Promo = response.Entities[0];
                        });
                        if (Promo != undefined) {
                            if (Promo.ApplicableOn == 163) {
                                if (Promo.DiscountOn == "2") {
                                    Discount = (ProductLabour[i] * Promo.DiscountPercentage) / 100
                                }
                                else {
                                    Discount = Promo.DiscountAmount;
                                }
                            }
                            else {
                                if (Promo.DiscountOn == "2") {
                                    Discount = (ProductAmount[i] * Promo.DiscountPercentage) / 100
                                }
                                else {
                                    Discount = Promo.DiscountAmount;
                                }

                            }

                            var PromoAmount = Promo.ApplicableOn == 163 ? ProductLabour[i] : ProductAmount[i];
                            //this.form.Discount.value += Discount;
                            var NewPromo: ECommOrderPromoRow = {
                                PromoId: Promo.PromoId,
                                PromoPer: Promo.DiscountPercentage,
                                ProductTypeId: ProductType[i],
                                TotalAmount: PromoAmount,
                                PromoAmount: Discount,
                                PromoCode: Promo.PromoCode,
                                ProductTypeName: Promo.ProductTypeName
                            }

                            Promos.push(NewPromo);
                        }
                    }
                }

                var temp2 = this.form.PromoDetails.getData(Promos);
                this.form.PromoDetails.view.setItems(temp2, true);
                var PromoDiscount = 0;
                for (let i = 0; i < Promos.length; i++) {
                    PromoDiscount += Promos[i].PromoAmount;
                }
                this.form.NetAmount.value = gramt;
                this.form.Discount.value = PromoDiscount;
                var TaxAmount = 0;

                var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

                if (ItemTotal == TotalItems && TaxApplicable) {

                    //this.form.TaxAmount.value = TaxAmount;
                    this.form.GrossAmount.value = gramt + TaxAmount;
                    this.form.GrossAmount.value = gramt + TaxAmount - PromoDiscount;
                    this.form.Pieces.value = pcs;
                    this.form.Weight.value = wt;
                    this.form.NetWeight.value = nwt;
                }
                else {
                    this.form.GrossAmount.value = gramt - PromoDiscount;
                    this.form.GrossAmount.value = gramt;
                    this.form.Pieces.value = pcs;
                    this.form.Weight.value = wt;
                    this.form.NetWeight.value = nwt;
                }

                this.form.ItemDetails.render;
            }
        }

        public calculateReceiptTotal() {
            var Receipts = this.form.ReceiptDetails.getItems();
            var totalamount = 0;
            for (var i = 0; i < Receipts.length; i++) {
                totalamount += Receipts[i].Amount;

            }
            this.form.ReceiptAmount.value = totalamount;
        }

        protected onDialogOpen() {
            super.onDialogOpen();

            if (this.form.PartyId.value != undefined || this.form.PartyId.value != 0) {
             
            }
            else {
                this.form.GrossAmount.value = 0;
                this.form.ItemDetails.isUpdate = 0;
            }
          
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            let companyDetails = OMS.CompanyRow.getLookup().itemById[this.form.CompanyId.value];
            this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value.toString());
            this.RateListId = companyDetails.SPriceListId == null ? 0 : companyDetails.SPriceListId;
            this.LaborListId = companyDetails.SLabourListId == null ? 0 : companyDetails.SLabourListId;
            this.StoneMarkup = companyDetails.SMarkup == null ? 0 : companyDetails.SMarkup;
            //this.StoneDiscount = companyDetails.== null ? 0 : companyDetails.StnAddDisc;
            this.LaborMarkup = companyDetails.SLMarkup == null ? 0 : companyDetails.SLMarkup;
            if (this.form.POSCustomerId.value != "") {

                Serenity.EditorUtils.setReadOnly(this.form.ShippingCity, false);

                Serenity.EditorUtils.setReadOnly(this.form.ShippingState, false);

                var address = this.entity.AddressDetails;
                for (var add of address) {
                    if (add.Type == 47) {
                        this.form.ShippingState.cascadeField = "CountryId";
                        this.form.ShippingState.cascadeValue = add.Country.toString();
                        this.form.ShippingCity.cascadeField = "StateId";
                        this.form.ShippingCity.cascadeValue = add.State.toString();
                        this.form.ShippingAddress.value = add.Address1.toString();
                        this.form.ShippingCity.value = add.City != null ? add.City.toString(): "0";
                        this.form.ShippingCityName.value = add.CityName;
                        this.form.ShippingState.value = add.State != null ? add.State.toString() : "0";
                        this.form.ShippingStateName.value = add.StateName;
                        this.form.ShippingCountry.value = add.Country.toString();
                        this.form.ShippingCountryName.value = add.CountryName;
                        this.form.ShippingPincode.value = add.Pincode.toString();
                    } else if (add.Type == 48) {
                        this.form.BillingAddress.value = add.Address1.toString();
                        this.form.BillingCity.value = add.City;
                        this.form.BillingCityName.value = add.City.toString();
                        this.form.BillingState.value = add.State != null ? add.State : 0;
                        this.form.BillingStateName.value = add.StateName;
                        this.form.BillingCountry.value = add.Country;
                        this.form.BillingCountryName.value = add.CountryName.toString();
                        this.form.BillingPin.value = add.Pincode.toString();
                    }
                }
            }

        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'ECommerce.Order',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));


            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            if (this.entity.OrderStatusId > 8) {
                Q.alert("This Voucher has been used in transactions Can Not Delete!");
                return;
            }
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.ProductName != null || refid.ProductName != "") {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            if (this.entity.OrderStatusId > 8) {
                Q.alert("This Voucher has been used in transactions Can Not Delete!");
                return;
            }
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                ECommOrderService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }

        validateBeforeSave() {
            var Isvalid = super.validateBeforeSave();
            if (this.form.ItemDetails.getItems().length == 0) {
                Q.alert("No Items added, At least add one entry. Can not Save! ")
                Isvalid = false;
            }
            for (var i = 0; i < this.form.ItemDetails.getItems().length; i++) {
                let items = this.form.ItemDetails.getItems();
                items[i].BOMDetails.forEach(function (x) {
                    if (x.BomRate == null || x.BomRate <= 0 || x.BomAmount == null || x.BomAmount <= 0) {
                        var msg = q.text('Message.Component.RateNotDefined', 'Rate not Defined for Component "' + items[i].ProductCode + '", Cannot Save!');
                        Q.alert(msg)
                        Isvalid = false;
                    }
                })

                if (items[i].LaborDetails.length > 0) {
                    items[i].LaborDetails.forEach(function (x) {
                        if (x.LabourRate == null|| x.LabourRate <= 0 || x.LabourAmount == null || x.LabourAmount <= 0) {
                            Q.alert("Rate not Defined for labor, Can not Save!")
                            Isvalid = false;
                        }
                    })
                }
            }

            return Isvalid;

        } 

        validateEntity(row: ECommerce.ECommOrderRow, id: number) {

            if (row.ItemDetails.length == 0) {
                Q.alert("No Items added, Atleast add one entry. Can not Save! ")
                return false;
            }
            var items = this.form.ItemDetails.getItems();
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                item.BagNo = item.BagNo == undefined ? "NA" : item.BagNo;
                item.LotNo = item.LotNo == undefined ? "NA" : item.LotNo;
                item.SKU = item.SKU == undefined ? "0" : item.SKU;
                item.RefVoucherId = item.RefVoucherId == null? 0 : item.RefVoucherId;
                item.RefTransId = item.RefTransId == null? 0 : item.RefTransId;
                item.RefTransItemId = item.RefTransItemId == null? 0 : item.RefTransItemId;
                item.RefNo = item.RefNo == undefined ? "0" : item.RefNo;
                item.DepartmentId = item.DepartmentId == null ? 0 : item.DepartmentId;
                item.CertificateNo = item.CertificateNo == undefined ? "NA" : item.CertificateNo;
                item.Lab = item.Lab == undefined ? "NA" : item.Lab;
                item.MetalAmount = item.MetalAmount == null? 0 : item.MetalAmount;
                item.DiamondAmount = item.DiamondAmount == null? 0 : item.DiamondAmount;
                item.StoneAmount = item.StoneAmount == null? 0 : item.StoneAmount;
                item.OtherAmount = item.OtherAmount == undefined ? 0 : item.OtherAmount;
            } 
        }
        validateShippingAddress() {
            var shippingcity = this.form.ShippingCity.value;
            var shippingstate = this.form.ShippingState.value;
            var shippingcountry = this.form.ShippingCountry.value;
            var shippingaddress = this.form.ShippingAddress.value;
            var shippingpin = this.form.ShippingPincode.value;
            if (shippingcity == "" && shippingstate == "" && shippingcountry == "" && shippingaddress == "" && shippingpin == "") {
                Serenity.EditorUtils.setRequired(this.form.ShippingCity, false);
                Serenity.EditorUtils.setRequired(this.form.ShippingState, false);
                Serenity.EditorUtils.setRequired(this.form.ShippingCountry, false);
                Serenity.EditorUtils.setRequired(this.form.ShippingAddress, false);
                Serenity.EditorUtils.setRequired(this.form.ShippingPincode, false);

            }
            if (shippingcity != "" || shippingstate != "" || shippingcountry != "" || shippingaddress != "" || shippingpin != "") {
                q.showAndSetRequiredField(this.form.ShippingCity);
                q.showAndSetRequiredField(this.form.ShippingState);
                q.showAndSetRequiredField(this.form.ShippingCountry);
                q.showAndSetRequiredField(this.form.ShippingAddress);
                q.showAndSetRequiredField(this.form.ShippingPincode);


            }
        }
    }
}